import React from 'react';
import { Button, Card } from 'react-bootstrap';
import ModalReport from '../../../Utiles/Componentes/ModalReport';
import DepartamentoSelector from '../../Inventario/Departamento/Selector';
import Fechas from '../Fechas';
import { don } from '@victorequena22/conneccion';
interface State {
    date1: string
    date2: string
    aux: string
    departamento: string
    modal: boolean
}

let date = new Date();
export default class ItensNota extends React.Component<any, State> {
    state = { departamento: 'TODO', aux: "mes", date1: date.getFullYear() + '', date2: (date.getMonth() + 1) + '', modal: false, modalProductos: false }
    render() {
        let { aux, date2, date1, modal, departamento } = this.state;
        return (<Card>
            <ModalReport title={"PRODUCTOS EN NOTAS DE ENTREGA"} open={modal}
                url={don + "/api/Nota/productos/" + departamento + '/' + aux + '/' + date1 + '/' + date2}
                close={() => { this.setState({ modal: !modal }) }} />
            <Card.Header className='bg-info'>
                <h3>PRODUCTOS EN NOTAS DE ENTREGA</h3>
            </Card.Header>
            <Card.Body>
                <Card>
                    <Card.Header className='bg-info'>
                        <h6>FILTRAR POR DEPARTAMENTO</h6>
                    </Card.Header>
                    <Card.Body>
                        <DepartamentoSelector change={(departamento) => { this.setState({ departamento }) }} defaultValue={departamento} />
                    </Card.Body>
                </Card>
                <Fechas aux={aux} date2={date2} date1={date1} setDate={this.setState.bind(this)} />
                <Button className="float-right" onClick={() => { this.setState({ modal: !modal }) }} variant='primary'>
                    <span className="glyphicon glyphicon-print"></span> IMPRIMIR
                </Button>
            </Card.Body>
        </Card>)
    }
}